import type { FC, ReactNode } from "react";

import { Tooltip, TooltipContent, TooltipTrigger } from "../tooltip";
import { useAppNav } from "./app-nav-provider";

export interface AppNavTooltipProps {
  children: ReactNode;
  label?: string;
  hidden?: boolean;
}

export const AppNavTooltip: FC<AppNavTooltipProps> = ({ children, label, hidden }) => {
  const { isCollapsed, side } = useAppNav();

  if (isCollapsed) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        {label && (
          <TooltipContent hidden={hidden} side={side === "left" ? "right" : "left"}>
            {label}
          </TooltipContent>
        )}
      </Tooltip>
    );
  }

  return children;
};
